// extracted by mini-css-extract-plugin
export default {"react-select":"style_react-select__YmD0c"};